<template>
  <div class="app-gray">
    <b-breadcrumb :items="breaditem" class="breadcrumb-color"></b-breadcrumb>
    <b-container class="details">
      <b-row class="breadrow">
        <b-col cols="12" md="8" class="phone-pad0" style="padding-right:0px">
          <slot></slot>
        </b-col>
        <b-col cols="12" md="4">
          <ul class="detail-right" v-if="listType == 1">
            <li class="detail-title">{{ detailTitle }}</li>
            <li
              :class="[active == item.id ? 'active' : '']"
              v-for="(item, index) of DetailsList"
              :key="index"
              @click="ListClick(item.id)"
            >
              <a class="maxLength-text-1">{{ item.text }}</a>
            </li>
          </ul>
          <ul class="detail-right" v-if="listType == 2">
            <li class="detail-title">{{ detailTitle }}</li>
            <li
              :class="[active == item.id ? 'active' : '']"
              v-for="(item, index) of DetailsList"
              :key="index"
              @click="ListClick(item.id)"
            >
              <div class="detail-list">
                <img :src="getImgUrl(item.img)" alt />
                <div class="detail-list-text">
                  <h5 class="maxLength-text-1">{{ item.text }}</h5>
                  <p>
                    {{
                      item.info && item.info.jobExperiences
                        ? "经验" + item.info.jobExperiences
                        : ""
                    }}
                    {{
                      item.info && item.info.age
                        ? existData(item.info, "age", " | ") + "岁"
                        : ""
                    }}
                    {{ existData(item.educations, "major", " | ") }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <Collapse
            v-if="listType == 3"
            :projectTypeData="DetailsList"
            :onChangeImgUr="onChangeImgUr"
            class="category-collapses"
          ></Collapse>
          <slot v-if="listType == 3" name="project"></slot>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Collapse from "@/components/collapse.vue";
export default {
  name: "detail",
  props: {
    breaditem: {
      type: Array
    },
    detailTitle: {
      type: String
    },
    DetailsList: {
      type: Array
    },
    ListClick: {
      type: Function
    },
    active: {
      type: Number,
      default: 0
    },
    listType: {
      type: Number,
      default: 1
    },
    onChangeImgUr: {
      type: Function
    }
  },
  components: {
    Collapse
  },
  methods: {
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    }
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb-color {
  background: inherit;
}
</style>
